import {
  Component,
  Directive,
  EventEmitter,
  HostListener,
  inject,
  Input,
  OnInit,
  QueryList,
  ViewChildren,
  ViewEncapsulation
} from '@angular/core';
import { Session } from '@models/session';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { OverlayService } from '@services/overlay';
import { CloseOverlayKeyboardDirective, CloseOverlayClickDirective } from '../../directives/close-overlay.directives';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

@Directive({ selector: '[lvReasonCheck]' })
export class ReasonCheckboxDirective {
  @Input() index: number;
  checked: boolean;

  @HostListener('change') toggle() {
    this.checked = !this.checked;
  }
}

@Component({
  selector: 'lv-session-failed-reason',
  templateUrl: 'session-failed-reason.component.html',
  styleUrls: ['session-failed-reason.component.scss'],
  encapsulation: ViewEncapsulation.None,
  imports: [
    CommonModule,
    CloseOverlayKeyboardDirective,
    TranslateModule,
    CloseOverlayClickDirective,
    FormsModule,
    ReasonCheckboxDirective
  ]
})
export class SessionFailedReasonComponent implements OnInit {
  private overlayService = inject(OverlayService);
  private translate = inject(TranslateService);

  @ViewChildren(ReasonCheckboxDirective) reasons: QueryList<ReasonCheckboxDirective>;

  @Input() session: Session;
  @Input() submitted: EventEmitter<string>;

  reason = '';

  cannedReasons: Array<string>;

  ngOnInit() {
    this.translate.get('session-failed-reason.component.canned-reasons').subscribe((res) => (this.cannedReasons = res));
  }

  updateReasons() {
    this.reason = this.reasons.reduce(
      (comment, reason) => comment + (reason.checked ? `${this.cannedReasons[reason.index]}\n` : ''),
      ''
    );
  }

  submit() {
    this.submitted.emit(this.reason);
    this.overlayService.closeTopOverlay();
  }
}
